/**
 * Rejects whitespace-only values on fields marked [data-no-blank].
 *
 * HTML `required` only checks that a value is non-empty, so a single space satisfies it.
 * `pattern` would cover the text inputs but is not supported on <textarea>, so the check
 * lives here and uses the constraint validation API -- the field reports through the
 * browser's own validation bubble like any other required field.
 */
(function () {
  if (window.__cmfBlankFieldGuard) return
  window.__cmfBlankFieldGuard = true

  var SELECTOR = '[data-no-blank]'
  var MESSAGE = 'Please fill out this field.'

  function isWhitespaceOnly(field) {
    return field.value.length > 0 && field.value.trim() === ''
  }

  function validate(field) {
    if (typeof field.setCustomValidity !== 'function') return
    field.setCustomValidity(isWhitespaceOnly(field) ? MESSAGE : '')
  }

  // Clear or set the error as the shopper types, so a corrected field stops complaining.
  document.addEventListener('input', function (event) {
    var field = event.target.closest && event.target.closest(SELECTOR)
    if (field) validate(field)
  })

  /**
   * Native validation runs before the submit event, so by the time we get here the form
   * has already passed `required`. Re-check the guarded fields to catch values that never
   * fired an input event -- autofill, or a space typed before this script loaded.
   */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target
      if (!form || typeof form.querySelectorAll !== 'function') return

      var guarded = Array.prototype.slice.call(form.querySelectorAll(SELECTOR))
      if (!guarded.length) return

      guarded.forEach(validate)

      if (!form.checkValidity()) {
        event.preventDefault()
        if (typeof form.reportValidity === 'function') form.reportValidity()
      }
    },
    true
  )
})()
